<template>
  <div class="tags-list">
    <el-tag
      :key="tag"
      class="positive"
      v-for="tag in filterstTags.positiveTags"
      closable
      :disable-transitions="false"
      @close="handlePositiveClose(tag)">
      {{tag}}
    </el-tag>
    <el-tag
      :key="tag"
      class="negative"
      v-for="tag in filterstTags.negativeTags"
      closable
      :disable-transitions="false"
      @close="handleNegativeClose(tag)">
      {{tag}}
    </el-tag>
    <el-tag
      :key="tag"
      class="neutral"
      v-for="tag in filterstTags.neutralTags"
      closable
      :disable-transitions="false"
      @close="handleNeutralClose(tag)">
      {{tag}}
    </el-tag>
  </div>
</template>
<script>
export default {
  props: {
    filters: {
      type: Object
    }
  },
  data() {
    return {
      filterstTags: {
        positiveTags: [],
        negativeTags: [],
        neutralTags: []
      },
      positive: [],
      negative: [],
      neutral: []
    };
  },
  methods: {
    handlePositiveClose(tag) {
      this.filterstTags.positiveTags.splice(this.filterstTags.positiveTags.indexOf(tag), 1);
      this.changeEvent();
    },
    handleNegativeClose(tag) {
      this.filterstTags.negativeTags.splice(this.filterstTags.negativeTags.indexOf(tag), 1);
      this.changeEvent();
    },
    handleNeutralClose(tag) {
      this.filterstTags.neutralTags.splice(this.filterstTags.neutralTags.indexOf(tag), 1);
      this.changeEvent();
    },
    changeEvent() {
      this.$emit('change', {
        positive: this.filterstTags.positiveTags || [],
        negative: this.filterstTags.negativeTags || [],
        neutral: this.filterstTags.neutralTags || []
      });
    }
  },
  watch: {
    'filters.positive'(newVal) {
      this.filterstTags.positiveTags = newVal;
    },
    'filters.negative'(newVal) {
      this.filterstTags.negativeTags = newVal;
    },
    'filters.neutral'(newVal) {
      this.filterstTags.neutralTags = newVal;
    }
  },
  mounted() {
    this.filterstTags.positiveTags = this.filters.postive;
    this.filterstTags.negativeTags = this.filters.negative;
    this.filterstTags.neutralTags = this.filters.neutral;
  }
};
</script>
<style lang="scss" scoped>
.tags-list {
  display: flex;
  flex-wrap: wrap;
  /deep/ {
    .el-tag {
      height: 24px;
      margin: 4px;
      background-color: #38353a;
      border-radius: 4px;
      font-size: 12px;
      line-height: 24px;
      border: none;
      .el-icon-close {
        &:before {
          content: '';
          display: inline-block;
          width: 14px;
          height: 14px;
          background: url('../../assets/img/close-circle-normal.svg') no-repeat;
          background-size: cover;
        }
        &:hover {
          background-color: transparent;
          &:before {
            content: '';
            display: inline-block;
            width: 14px;
            height: 14px;
            background: url('../../assets/img/close-circle-hover.svg') no-repeat;
            background-size: cover;
          }
        }
      }
      &.positive {
        font-size:14px;
        color: #fe4954;
        font-family: "DIN-Regular"; 
        background-color: #262429;
      }
      &.negative {
        font-size:14px;
        color: #54cea4;
        font-family: "DIN-Regular"; 
        background-color: #262429;
      }
      &.neutral {
        font-size:14px;
        color: #5ac8ff;
        font-family: "DIN-Regular"; 
        background-color: #262429;
      }
    }
  }
}
</style>
